import React, { useCallback } from 'react';
import { Trans } from 'react-i18next';
import { notification } from 'src/components/Notification';

export default (email) => {
  return useCallback(async () => {
    try {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");

      const raw = JSON.stringify({
        "client_id": AUTH0_CLIENT_ID,
        email,
        connection: 'Username-Password-Authentication'
      });

      const requestOptions = {
        method: 'POST',
        headers,
        body: raw,
        redirect: 'follow'
      };

      await fetch(`https://${AUTH0_DOMAIN}/dbconnections/change_password`, requestOptions);

      notification.success(
        <Trans>RESTORE_PASSWORD_NOTIFICATION_SUCCESS</Trans>,
      );
    } catch (e) {
      notification.error(e);
    }
  }, [email]);
};
